import type { UseMutationResult } from "@tanstack/react-query"

import { useSolarLightReachCommand } from "./solar-lightreach-cache"
import type {
  SolarLightReachDto,
  SubmitSolarLightReachApplicationDto,
} from "../dto/solar-lightreach.dto"
import { solarProposalService } from "../services/solar-proposal.service"

type SubmitVariables = {
  proposalId: string
  body: SubmitSolarLightReachApplicationDto
}

/**
 * Submit and re-apply share everything but the route. The variables carry
 * SSNs, so nothing keeps the mutation once unobserved; a failure may still
 * have left a held application (LightReach did not confirm), which the
 * `application` scope reads again.
 */
const UNKEPT = { cacheTime: 0 }

/** Submit the seller's LightReach credit application for the selected offer. */
export default function useSubmitSolarLightReachApplication(): UseMutationResult<
  SolarLightReachDto,
  unknown,
  SubmitVariables
> {
  return useSolarLightReachCommand(
    ({ proposalId, body }) =>
      solarProposalService.submitLightReachApplication(proposalId, body),
    `application`,
    UNKEPT,
  )
}

/**
 * Apply again after LightReach declined, froze or expired the application;
 * the earlier one stays as history.
 */
export function useReapplySolarLightReach(): UseMutationResult<
  SolarLightReachDto,
  unknown,
  SubmitVariables
> {
  return useSolarLightReachCommand(
    ({ proposalId, body }) =>
      solarProposalService.reapplyLightReach(proposalId, body),
    `application`,
    UNKEPT,
  )
}
